module.exports = __webpack_public_path__ + "static/img/docusing.b8bed281.svg";